<template>
    <div :style="`margin-inline-start:10px;padding:5px;width:100%;margin-top:10px !important;direction:${$parent.lang.dir}`" class="mt-10">
        <div style="display:inline-flex;padding:0 5px" v-for="(tab,index) of tabs" :key="index">
            <b-button v-if="tab.class == 'mytab' && tab.style == '' && checkIf(index)" style="background:#000 !important;font-weight:bold;" :class="`btn-sm btn tabBtn `+tab.smclass" @click='goTo(tab.href,tab.main)'>{{tab.name}}  <i class="fas fa-arrow-down"></i></b-button>
            <b-button v-else-if="tab.class == 'mytab' && tab.style != '' && checkIf(index)" :style="`background:#000 !important;font-weight:bold;`+tab.style" :class="`btn-sm btn tabBtn `+tab.smclass" @click='goTo(tab.href,tab.main)'>{{tab.name}}  <i class="fas fa-arrow-down"></i></b-button>
            <b-button v-else-if="checkIf(index)" :class="`btn-sm btn tabBtn `+tab.smclass" :style="`background:#eee !important;color:black !important;font-weight:bold;`+tab.style" @click='goTo(tab.href,tab.main)'>{{tab.name}} </b-button>
        </div>
    </div>
</template>
<script>

export default{
    props: [
      'tabs'
    ],
    methods: {
        checkIf(index){
          for(let i=0; i< this.tabs[index].perms.length;i++){
            
            if(this.tabs[index].perms[i] == 'any') return true;

            if(this.$store.state.licenseType[this.tabs[index].perms[i]]){
              return true;
            }
          }
          return false
        },
        goTo(path,main){
            localStorage.setItem("currentMenu",main);
            this.$router.push({path: path})
        },
        checkLink(){
          let t = false;
          let path = '';
          for(let i=0;i<this.tabs.length;i++){
            if(this.$route.path == this.tabs[i].href){
              t = true
            }
            if(i == 0){
              path = this.tabs[0].href;
            }
          }
          console.log("tt",t);
          if(!t){
            this.$router.push({path: path})
          } 
        }
    },
    created() {
      setTimeout(() => {this.checkLink()},1000)

    
      },
}
</script>

<style>
.mytab{
  width:100%;
  border:0px solid #fff;
}
.mytab2{
  width:100%;
  background:rgb(4, 112, 155) !important;
  color:#FFF;
  border:0px solid #fff;
}
.mytab4{
  width:100%;
  background:rgb(15, 90, 230) !important;
  border:0px solid #fff;
}
.mytab3{
  width:100%;
  background:#198754 !important;
  border:0px solid #fff;
}
.mytab1{
  width:100%;
  background:#fe7b33 !important;
  border:0px solid #fff;
}
.mytab5{
  width:100%;
  background:#339cfe !important;
  border:0px solid #fff;
}
.mytab6{
  width:100%;
  background:#fe3344 !important;
  border:0px solid #fff;
}
.font-small{
  font-size:.8em !important;
  width:120px !important;
}
.tabBtn{
  white-space: nowrap;
  width:125px;
  font-size:0.8rem;
}
@media  only screen and (max-width: 1100px){
    .btn-sm{
      font-size:.6rem !important;
    }
    .tabBtn{
        width:100px;
        font-size:.7rem;
    }
    .refIcon{
        top:30px;
        left: 10px;
        font-size:.6rem;

    }
}
</style>
